import React from 'react';

const StatisticsSection = ({ statisticsContentBlurb }) => {
  if (!statisticsContentBlurb?.content) return false;

  return (
    <div
      className="demographics-statistics-content-blurb newContentBlurbContainer"
      dangerouslySetInnerHTML={{ __html: statisticsContentBlurb.content }}
    />
  );
};

export default StatisticsSection;
